import PropTypes from 'prop-types';

import TagCloseButton from './TagCloseButton';

import './styles.css';

const defaultPalette = {
  default: {
    button: 'text-white',
    tag: 'bg-gray-5 text-white',
  },
  info: {
    button: 'text-white',
    tag: 'bg-blue-3 text-white',
  },
  success: {
    button: 'text-white',
    tag: 'bg-green-3 text-white',
  },
  warning: {
    button: 'text-orange-5',
    tag: 'bg-orange-3 text-orange-5',
  },
  danger: {
    button: 'text-white',
    tag: 'bg-red-4 text-white',
  },
  secondary: {
    button: 'text-white',
    tag: 'bg-cyan-4 text-white',
  },
  pantheor: {
    button: 'text-white',
    tag: 'bg-purple-3 text-white',
  },
};

const subtlePalette = {
  default: {
    button: 'text-gray-5',
    tag: 'bg-gray-2 text-gray-5',
  },
  info: {
    button: 'text-blue-4',
    tag: 'bg-blue-1 text-blue-4',
  },
  success: {
    button: 'color-green-4',
    tag: 'bg-green-1 color-green-4',
  },
  warning: {
    button: 'text-orange-5',
    tag: 'bg-orange-1 text-orange-5',
  },
  danger: {
    button: 'text-red-4',
    tag: 'bg-red-1 text-red-4',
  },
  secondary: {
    button: 'text-cyan-5',
    tag: 'bg-cyan-1 text-cyan-5',
  },
  pantheor: {
    button: 'text-purple-4',
    tag: 'bg-purple-1 text-purple-4',
  },
};

const palettes = {
  default: defaultPalette,
  subtle: subtlePalette,
};

// Use keys from default palette for props validation
export const TAG_TYPES = Object.keys(palettes.default);

const TagBase = ({ children, onClose, palette, type, ...props }) => (
  <span
    {...props}
    className={`tag inline-flex flex-row items-center justify-center rounded ${palettes[palette][type].tag}`}
  >
    <span
      className="tag-truncated text-ellipsis overflow-hidden whitespace-nowrap"
      title={children}
    >
      {children}
    </span>
    {onClose && (
      <TagCloseButton
        callback={onClose}
        className={palettes[palette][type].button}
      />
    )}
  </span>
);

TagBase.defaultProps = {
  onClose: null,
};

TagBase.propTypes = {
  children: PropTypes.node.isRequired,
  onClose: PropTypes.func,
  palette: PropTypes.oneOf(Object.keys(palettes)).isRequired,
  type: PropTypes.oneOf(TAG_TYPES).isRequired,
};

const Tag = (props) => <TagBase palette="default" {...props} />;
const TagSubtle = (props) => <TagBase palette="subtle" {...props} />;

const defaultProps = {
  type: 'default',
};

const propTypes = {
  children: PropTypes.node.isRequired,
  type: PropTypes.oneOf(TAG_TYPES),
};

Tag.defaultProps = defaultProps;
Tag.propTypes = propTypes;
TagSubtle.defaultProps = defaultProps;
TagSubtle.propTypes = propTypes;

export { Tag, TagSubtle };
